// extracted by mini-css-extract-plugin
module.exports = {"infoDescription":"_f170859","infoValue":"_3e93126"};